import styled from 'styled-components';

import { style } from '@genially/design-system';
import { ArrowRightToBracketIcon } from '@genially/icons';

export const IconWrapper = styled.div(({ theme: { color, size } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '100%',
  backgroundColor: color.background.danger.default(),
  border: `2px solid ${color.border.primary.hover()}`,

  ...style.mixins.responsive.xs.downward({
    width: size.units(4),
    height: size.units(4),
  }),
}));

export const StyledArrowRightToBracketIcon = styled(ArrowRightToBracketIcon)(
  ({ theme: { color } }) => ({
    color: color.content.reversed.default(),
  }),
);
